Lib.Clipboard = (function() {

    var self = {};


    $(Lib).on('document.ready', function() {

        // Go
        var clipboard = new ClipboardJS('[data-clipboard-text]');

        // In debug, log to the console what we copied
        clipboard.on('success', function(e) {
            $(Lib).trigger('clipboard.success', [e]);
            if (Lib.Debug.isDebug()) {
                Lib.Debug.log('Copied to clipboard: ' + e.text);
            }
        });

        // In debug, log to the console what we copied
        clipboard.on('error', function(e) {
            $(Lib).trigger('clipboard.error', [e]);
            if (Lib.Debug.isDebug()) {
                Lib.Debug.error('Failed to copy to clipboard');
            }
        });
    });

    return self;

})();
